import React, { ReactNode, Fragment, useState, useEffect } from "react";

// Components (+ related types)
import { ProjectItem, ProjectItemProps } from "./components";

// Types
import { FetchedProjectsProps } from "./FetchedProjects.interface";
import { RepositoryData } from "./types";

// Styles
import "./FetchedProjects.styles.scss";

export const FetchedProjects = ({ username }: FetchedProjectsProps) => {
  const [projects, setProjects] = useState<ProjectItemProps[]>([]);
  const [error, setError] = useState<Error | null>(null);

  const fetchUrl = `https://api.github.com/users/${username}/repos?sort=created&direction=asc`;

  useEffect(() => {
    fetch(fetchUrl)
      .then((resp) => {
        if (!resp.ok) {
          setError(new Error(`${resp.status} ${resp.statusText}`.trim()));
        }
        return resp.json();
      })
      .then((resp: RepositoryData[]) => {
        const projects = resp.filter((repo): repo is ProjectItemProps => {
          console.log(repo);
          return !!repo.homepage;
        });

        setProjects(projects);
      });
  }, [fetchUrl]);

  const fetchResult: ReactNode = error ? (
    <div className={"fetched-projects__error"}>{error.toString()}</div>
  ) : projects.length > 0 ? (
    <>
      {projects.map((project) => (
        <ProjectItem key={project.name} {...project} />
      ))}
    </>
  ) : (
    <div className={"fetched-projects__loading"}>Loading...</div>
  );

  return <div className="fetched-projects">{fetchResult}</div>;
};
